import mapKnownValues from "../utils/mapKnownValues";

export type AggregatorLinkResponse = {
  aggregatorLinkId: number;
  aggregatorProviderName: string;
  destinationAccountId: string | null;
  itemAccessToken: string | null;
  itemId: string;
  sourceAccountId: number;
  aggregatorUpdateRequired: boolean;
};

export default class AggregatorLink {
  aggregatorUpdateRequired = false;
  aggregatorLinkId = -1;
  aggregatorProviderName = "";
  destinationAccountId: string | null = null;
  itemAccessToken: string | null = null;
  itemId = "";
  sourceAccountId = -1;

  constructor(params: Partial<AggregatorLink> = {}) {
    mapKnownValues(this, params);
  }

  static fromAPI(response: AggregatorLinkResponse) {
    return new AggregatorLink(response);
  }
}
